mainApp.directive('healthBar', ['$timeout', function($timeout) {
    return {
        templateUrl: '/public/directives/charts/healthBar.html',
        replace: true,
        scope: {
            options: "=",
            statsList: "=",
            startTime: "=",
            endTime: "=",
            middleTime: "=",
            active: "@",
            clickEvent: "&"
        },
        link: function ($scope, el) {
            $scope.statuses = ["NA", "HARD_LIMIT", "SOFT_LIMIT", 'PASSIVE', ""];
            $scope.rulerId = "ruler" + $scope.$id;
            var rulerChart;

            function makeChart(){
                if (!$scope.showTicks) {
                    return;
                }
                // we're using this inline ruler instead of the ruler directive because this allows for much better
                // update of the ruler when going over graphs quickly
                var data = [
                    {
                        value: 0,
                        time: $scope.startTime
                    },
                    {
                        value: 0,
                        time: $scope.endTime
                    }
                ];

                if(rulerChart){
                    rulerChart.dataProvider = data;
                    rulerChart.valueAxes[0].minimumDate = $scope.startTime;
                    rulerChart.valueAxes[0].maximumDate = $scope.endTime;
                    rulerChart.validateData();
                }
                else {
                    rulerChart = AmCharts.makeChart($scope.rulerId, {
                        "type": "serial",
                        fontFamily: 'Roboto',
                        addClassNames: true,
                        "path": "/public/javascripts/external/amcharts/",
                        "pathToImages": "/public/javascripts/external/amcharts/images/",
                        "categoryField": "time",
                        theme: "new",
                        autoMargins: false,
                        marginTop: 0,
                        marginBottom: 30,
                        marginLeft: 0,
                        marginRight: 0,
                        "categoryAxis":{
                            gridAlpha: 0.15,
                            "minPeriod": "2500fff",
                            markPeriodChange: true,
                            "parseDates": true,
                            centerLabelOnFullPeriod: false,
                            dateFormats: [{period:'fff',format:'JJ:NN:SS'},{period:'ss',format:'JJ:NN:SS'},{period:'mm',format:'JJ:NN'},{period:'hh',format:'JJ:NN'},{period:'DD',format:'MMM DD'},{period:'WW',format:'MMM DD'},{period:'MM',format:'MMM'},{period:'YYYY',format:'YYYY'}]
                        },
                        "graphs":  [{
                            "fillAlphas": 1,
                            "lineAlpha": 0.2,
                            "type": "column",
                            "valueField": "value"
                        }],
                        "guides": [],
                        "dataProvider": data,
                        valueAxes: [{
                            maximum: 0,
                            minimum: 0,
                            minimumDate: $scope.startTime,
                            maximumDate: $scope.endTime
                        }]
                    } );
                }

                $timeout(function() {
                    $('[data-toggle="tooltip"]').tooltip();
                }, 1, false);
            }
            angular.element(document).ready(function(){
                makeChart();
            });

            $scope.$watch("startTime", function(){
                if($scope.startTime){
                    makeChart();
                }
            });

            $scope.clickSegment = function ($event, item) {
                if ($scope.clickEvent) {
                    $scope.clickEvent({$event: $event, item: item});
                }
            };

            $scope.ceil = Math.ceil;

            $scope.$on('$destroy',function() {
                $(el[0]).find('[data-toggle="tooltip"]').tooltip('destroy');
            });
        }
    }
}]);